import { render } from "./ClonedParts.vue?vue&type=template&id=88ec3b42&scoped=true"
import script from "./ClonedParts.vue?vue&type=script&lang=js"
export * from "./ClonedParts.vue?vue&type=script&lang=js"

import "./ClonedParts.vue?vue&type=style&index=0&id=88ec3b42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88ec3b42"]])

export default __exports__